import { handleActions } from 'redux-actions';
import { StashState } from '../types/store';

const defaultState: StashState = {
  isVisitorView: false,
};

const reducer = handleActions<StashState, any>({}, defaultState);

export default reducer;
